<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- ── Breadcrumb ─────────────────────────────────────────────── -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite: p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Registros Eliminados
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 28px; cursor: pointer"
          @click="showModalHelp = true"
          title="Ayuda"
        >help</span>
      </div>
    </div>
    <hr />

    <!-- ── Info del trámite ───────────────────────────────────────── -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert" v-if="datosTramite">
      <span class="material-symbols-outlined align-middle me-1" style="font-size:18px">info</span>
      <strong>{{ datosTramite }}</strong>
    </div>

    <!-- ── Tabs Planillas / Detalles ─────────────────────────────── -->
    <ul class="nav nav-tabs mb-3" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: tabActivo === 'planillas' }"
          @click="cambiarTab('planillas')"
          type="button"
        >
          <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">assignment</span>
          Planillas eliminadas
          <span v-if="planillas.length > 0" class="badge bg-danger ms-1">{{ planillas.length }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: tabActivo === 'detalles' }"
          @click="cambiarTab('detalles')"
          type="button"
        >
          <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">list_alt</span>
          Detalles eliminados
          <span v-if="detalles.length > 0" class="badge bg-danger ms-1">{{ detalles.length }}</span>
        </button>
      </li>
    </ul>

    <!-- ══════════════════════════════════════════════════════════════
         TAB: PLANILLAS
    ═══════════════════════════════════════════════════════════════ -->
    <div v-show="tabActivo === 'planillas'">
      <!-- Barra de acciones -->
      <div class="action-bar mb-3">
        <button
          class="action-btn action-btn--green"
          @click="exportarExcelPlanillas"
          :disabled="planillas.length === 0 || cargandoPlanillas"
          title="Exportar a Excel"
        >
          <span class="material-symbols-outlined">table_view</span>
          Exportar Excel
        </button>

        <!-- Filtro global -->
        <div class="filter-input-wrap">
          <span class="material-symbols-outlined filter-icon">search</span>
          <input
            type="text"
            class="filter-input"
            v-model="filtroTextoPlanillas"
            placeholder="Buscar en todos los campos..."
            @input="paginarPlanillas(1)"
          />
          <button
            v-if="filtroTextoPlanillas"
            class="filter-clear"
            @click="filtroTextoPlanillas = ''; paginarPlanillas(1)"
            title="Limpiar filtro"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>

        <!-- Selector registros por página -->
        <div class="ms-auto d-flex align-items-center gap-2">
          <label class="form-label mb-0 small fw-bold">Mostrar</label>
          <select
            v-model.number="elementosPorPaginaPlanillas"
            class="form-select form-select-sm"
            style="width: 75px"
            @change="paginarPlanillas(1)"
          >
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span class="small text-muted">registros</span>
        </div>
      </div>

      <!-- Spinner -->
      <div v-if="cargandoPlanillas" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <!-- Tabla planillas -->
      <div class="table-responsive" v-if="planillas.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPorPlanilla('numero')">
                Número <span class="sort-icon">{{ iconOrdenPlanilla('numero') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('cedula')">
                Cédula <span class="sort-icon">{{ iconOrdenPlanilla('cedula') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('nombre')">
                Nombre Paciente <span class="sort-icon">{{ iconOrdenPlanilla('nombre') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('diag1')">
                Diag 1 <span class="sort-icon">{{ iconOrdenPlanilla('diag1') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('diag2')">
                Diag 2 <span class="sort-icon">{{ iconOrdenPlanilla('diag2') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('cedulaMedico')">
                Cédula Médico <span class="sort-icon">{{ iconOrdenPlanilla('cedulaMedico') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('fechaDesde')">
                F. Desde <span class="sort-icon">{{ iconOrdenPlanilla('fechaDesde') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('fechaHasta')">
                F. Hasta <span class="sort-icon">{{ iconOrdenPlanilla('fechaHasta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('estadoAud')">
                Estado AM <span class="sort-icon">{{ iconOrdenPlanilla('estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('estadoDoc')">
                Estado GD <span class="sort-icon">{{ iconOrdenPlanilla('estadoDoc') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorPlanilla('idCarga')">
                Periodo <span class="sort-icon">{{ iconOrdenPlanilla('idCarga') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in planillasPaginadas" :key="p.idPlanilla" @dblclick="abrirPlanillaPopup(p.idPlanilla)">
              <td>{{ p.numero }}</td>
              <td>{{ p.cedula }}</td>
              <td>{{ p.nombre }}</td>
              <td>{{ p.diag1 }}</td>
              <td>{{ p.diag2 }}</td>
              <td>{{ p.cedulaMedico }}</td>
              <td>{{ fmtFecha(p.fechaDesde) }}</td>
              <td>{{ fmtFecha(p.fechaHasta) }}</td>
              <td>
                <span class="badge" :class="badgeEstado(p.estadoAud)">{{ p.estadoAud }}</span>
              </td>
              <td>
                <span class="badge" :class="badgeEstado(p.estadoDoc)">{{ p.estadoDoc }}</span>
              </td>
              <td>{{ p.idCarga }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="11" class="text-end small">
                Mostrando {{ planillasPaginadas.length }} de {{ planillasFiltradas.length }} registros
                {{ filtroTextoPlanillas ? ' (filtrados de ' + planillas.length + ' totales)' : '' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div v-if="planillas.length === 0 && !cargandoPlanillas" class="alert alert-warning mt-3">
        No se encontraron planillas eliminadas para este trámite.
      </div>

      <!-- Paginación planillas -->
      <div class="d-flex justify-content-between align-items-center mt-2" v-if="planillas.length > 0">
        <span class="small text-muted">
          Página {{ paginaActualPlanillas }} de {{ totalPaginasPlanillas }} — {{ planillas.length }} registros
        </span>
        <nav aria-label="Paginación planillas">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: paginaActualPlanillas === 1 }">
              <a class="page-link" href="#" @click.prevent="paginarPlanillas(1)">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualPlanillas === 1 }">
              <a class="page-link" href="#" @click.prevent="paginarPlanillas(paginaActualPlanillas - 1)">‹</a>
            </li>
            <li
              v-for="pag in paginasVisiblesPlanillas"
              :key="pag"
              class="page-item"
              :class="{ active: pag === paginaActualPlanillas, disabled: pag === '...' }"
            >
              <a class="page-link" href="#" @click.prevent="pag !== '...' && paginarPlanillas(pag)">{{ pag }}</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualPlanillas === totalPaginasPlanillas }">
              <a class="page-link" href="#" @click.prevent="paginarPlanillas(paginaActualPlanillas + 1)">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualPlanillas === totalPaginasPlanillas }">
              <a class="page-link" href="#" @click.prevent="paginarPlanillas(totalPaginasPlanillas)">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         TAB: DETALLES
    ═══════════════════════════════════════════════════════════════ -->
    <div v-show="tabActivo === 'detalles'">
      <!-- Barra de acciones -->
      <div class="action-bar mb-3">
        <button
          class="action-btn action-btn--green"
          @click="exportarExcelDetalles"
          :disabled="detalles.length === 0 || cargandoDetalles"
          title="Exportar a Excel"
        >
          <span class="material-symbols-outlined">table_view</span>
          Exportar Excel
        </button>

        <!-- Filtro global -->
        <div class="filter-input-wrap">
          <span class="material-symbols-outlined filter-icon">search</span>
          <input
            type="text"
            class="filter-input"
            v-model="filtroTextoDetalles"
            placeholder="Buscar en todos los campos..."
            @input="paginarDetalles(1)"
          />
          <button
            v-if="filtroTextoDetalles"
            class="filter-clear"
            @click="filtroTextoDetalles = ''; paginarDetalles(1)"
            title="Limpiar filtro"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>

        <!-- Selector registros por página -->
        <div class="ms-auto d-flex align-items-center gap-2">
          <label class="form-label mb-0 small fw-bold">Mostrar</label>
          <select
            v-model.number="elementosPorPaginaDetalles"
            class="form-select form-select-sm"
            style="width: 75px"
            @change="paginarDetalles(1)"
          >
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span class="small text-muted">registros</span>
        </div>
      </div>

      <!-- Spinner -->
      <div v-if="cargandoDetalles" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <!-- Tabla detalles -->
      <div class="table-responsive" v-if="detalles.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPorDetalle('planillaNumero')">
                N.° Planilla <span class="sort-icon">{{ iconOrdenDetalle('planillaNumero') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('planillaCedula')">
                Cédula <span class="sort-icon">{{ iconOrdenDetalle('planillaCedula') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('planillaNombre')">
                Nombre Paciente <span class="sort-icon">{{ iconOrdenDetalle('planillaNombre') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('fechaAtencion')">
                F. Atención <span class="sort-icon">{{ iconOrdenDetalle('fechaAtencion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('elementoCodigo')">
                Código TPSNS <span class="sort-icon">{{ iconOrdenDetalle('elementoCodigo') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('elementoNombre')">
                Elemento TPSNS <span class="sort-icon">{{ iconOrdenDetalle('elementoNombre') }}</span>
              </th>
              <th class="th-sort text-end" @click="ordenarPorDetalle('cantidad')">
                Cantidad <span class="sort-icon">{{ iconOrdenDetalle('cantidad') }}</span>
              </th>
              <th class="th-sort text-end" @click="ordenarPorDetalle('valorUni')">
                Val. Unitario <span class="sort-icon">{{ iconOrdenDetalle('valorUni') }}</span>
              </th>
              <th class="th-sort text-end" @click="ordenarPorDetalle('valorTotal')">
                Val. Total <span class="sort-icon">{{ iconOrdenDetalle('valorTotal') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('codigo')">
                Cód. Prestador <span class="sort-icon">{{ iconOrdenDetalle('codigo') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPorDetalle('descripcion')">
                Desc. Prestador <span class="sort-icon">{{ iconOrdenDetalle('descripcion') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in detallesPaginados" :key="d.idPlanillaDet">
              <td>{{ d.planillaNumero }}</td>
              <td>{{ d.planillaCedula }}</td>
              <td>{{ d.planillaNombre }}</td>
              <td>{{ fmtFecha(d.fechaAtencion) }}</td>
              <td>{{ d.elementoCodigo }}</td>
              <td>{{ d.elementoNombre }}</td>
              <td class="text-end">{{ d.cantidad }}</td>
              <td class="text-end">{{ fmtNum(d.valorUni) }}</td>
              <td class="text-end fw-bold">{{ fmtNum(d.cantidad * d.valorUni) }}</td>
              <td>{{ d.codigo }}</td>
              <td>{{ d.descripcion }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td colspan="6" class="text-end small">TOTALES</td>
              <td class="text-end">{{ sumaCantidad }}</td>
              <td></td>
              <td class="text-end">{{ fmtNum(sumaValorTotal) }}</td>
              <td colspan="2"></td>
            </tr>
            <tr class="table-secondary">
              <td colspan="11" class="text-end small">
                Mostrando {{ detallesPaginados.length }} de {{ detallesFiltrados.length }} registros
                {{ filtroTextoDetalles ? ' (filtrados de ' + detalles.length + ' totales)' : '' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div v-if="detalles.length === 0 && !cargandoDetalles" class="alert alert-warning mt-3">
        No se encontraron detalles eliminados para este trámite.
      </div>

      <!-- Paginación detalles -->
      <div class="d-flex justify-content-between align-items-center mt-2" v-if="detalles.length > 0">
        <span class="small text-muted">
          Página {{ paginaActualDetalles }} de {{ totalPaginasDetalles }} — {{ detalles.length }} registros
        </span>
        <nav aria-label="Paginación detalles">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: paginaActualDetalles === 1 }">
              <a class="page-link" href="#" @click.prevent="paginarDetalles(1)">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualDetalles === 1 }">
              <a class="page-link" href="#" @click.prevent="paginarDetalles(paginaActualDetalles - 1)">‹</a>
            </li>
            <li
              v-for="pag in paginasVisiblesDetalles"
              :key="pag"
              class="page-item"
              :class="{ active: pag === paginaActualDetalles, disabled: pag === '...' }"
            >
              <a class="page-link" href="#" @click.prevent="pag !== '...' && paginarDetalles(pag)">{{ pag }}</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualDetalles === totalPaginasDetalles }">
              <a class="page-link" href="#" @click.prevent="paginarDetalles(paginaActualDetalles + 1)">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualDetalles === totalPaginasDetalles }">
              <a class="page-link" href="#" @click.prevent="paginarDetalles(totalPaginasDetalles)">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         MODAL AYUDA
    ═══════════════════════════════════════════════════════════════ -->
    <div v-if="showModalHelp" class="modal fade show d-block" tabindex="-1" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-symbols-outlined text-white me-2" style="font-size:20px">help</span>
            <h5 class="modal-title text-white">Ayuda — Registros Eliminados</h5>
            <button type="button" class="btn-close btn-close-white" @click="showModalHelp = false" />
          </div>
          <div class="modal-body">
            <p>
              Este módulo muestra los registros con <strong>borrado lógico</strong>
              (<code>estado = 0</code>) asociados al trámite.
            </p>
            <ul>
              <li>
                <strong>Planillas eliminadas</strong> — atenciones médicas que fueron
                marcadas como eliminadas en el sistema.
              </li>
              <li>
                <strong>Detalles eliminados</strong> — ítems de planilla (servicios,
                medicamentos, insumos, etc.) eliminados individualmente.
              </li>
            </ul>
            <p class="text-muted small mb-0">
              Use el campo de búsqueda para filtrar por cualquier columna visible.
              Los encabezados de columna son ordenables con clic.
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalHelp = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModalHelp" class="modal-backdrop fade show" @click="showModalHelp = false" />

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api    from "@/services/api";
import Swal   from "sweetalert2";
import * as XLSX from "xlsx";
import { abrirPlanillaPopup } from "@/assets/js/popup.js";

export default {
  name: "PlanillasBorradas",
  components: { Layout, Footer },

  props: {
    p_idtramite: { type: Number, required: true },
  },

  data() {
    return {
      // ── Tab activo ─────────────────────────────────────────────
      tabActivo: "planillas",

      // ── Info trámite ───────────────────────────────────────────
      datosTramite:  "",
      showModalHelp: false,

      // ── Planillas ──────────────────────────────────────────────
      planillas:                  [],
      planillasPaginadas:         [],
      paginaActualPlanillas:      1,
      elementosPorPaginaPlanillas: 25,
      cargandoPlanillas:          false,
      filtroTextoPlanillas:       "",
      campoOrdenPlanilla:         "numero",
      ascendentePlanilla:         true,

      // ── Detalles ───────────────────────────────────────────────
      detalles:                   [],
      detallesPaginados:          [],
      paginaActualDetalles:       1,
      elementosPorPaginaDetalles: 25,
      cargandoDetalles:           false,
      filtroTextoDetalles:        "",
      campoOrdenDetalle:          "planillaNumero",
      ascendenteDetalle:          true,
    };
  },

  computed: {
    // ── Planillas filtradas y ordenadas ────────────────────────
    planillasFiltradas() {
      const texto = this.filtroTextoPlanillas.toLowerCase().trim();
      let lista = this.planillas;
      if (texto) {
        lista = lista.filter(p =>
          [p.numero, p.cedula, p.nombre, p.diag1, p.diag2,
           p.cedulaMedico, p.estadoAud, p.estadoDoc]
            .some(v => (v ?? "").toString().toLowerCase().includes(texto))
        );
      }
      const campo = this.campoOrdenPlanilla;
      return [...lista].sort((a, b) => {
        let va = a[campo] ?? "";
        let vb = b[campo] ?? "";
        const cmp = typeof va === "number"
          ? va - vb
          : String(va).localeCompare(String(vb), "es");
        return this.ascendentePlanilla ? cmp : -cmp;
      });
    },

    totalPaginasPlanillas() {
      return Math.max(1, Math.ceil(this.planillasFiltradas.length / this.elementosPorPaginaPlanillas));
    },

    paginasVisiblesPlanillas() {
      return this._calcularPaginas(this.paginaActualPlanillas, this.totalPaginasPlanillas);
    },

    // ── Detalles filtrados y ordenados ─────────────────────────
    detallesFiltrados() {
      const texto = this.filtroTextoDetalles.toLowerCase().trim();
      let lista = this.detalles;
      if (texto) {
        lista = lista.filter(d =>
          [d.planillaNumero, d.planillaCedula, d.planillaNombre,
           d.elementoCodigo, d.elementoNombre, d.codigo, d.descripcion]
            .some(v => (v ?? "").toString().toLowerCase().includes(texto))
        );
      }
      const campo = this.campoOrdenDetalle;
      const numCampos = ["cantidad", "valorUni", "valorTotal"];
      return [...lista].sort((a, b) => {
        let va = a[campo] ?? "";
        let vb = b[campo] ?? "";
        const cmp = numCampos.includes(campo)
          ? Number(va) - Number(vb)
          : String(va).localeCompare(String(vb), "es");
        return this.ascendenteDetalle ? cmp : -cmp;
      });
    },

    totalPaginasDetalles() {
      return Math.max(1, Math.ceil(this.detallesFiltrados.length / this.elementosPorPaginaDetalles));
    },

    paginasVisiblesDetalles() {
      return this._calcularPaginas(this.paginaActualDetalles, this.totalPaginasDetalles);
    },

    // ── Totales detalles ───────────────────────────────────────
    sumaCantidad() {
      return this.detallesFiltrados.reduce((acc, d) => acc + (Number(d.cantidad) || 0), 0);
    },

    sumaValorTotal() {
      return this.detallesFiltrados.reduce(
        (acc, d) => acc + (Number(d.cantidad) || 0) * (Number(d.valorUni) || 0),
        0
      );
    },
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.datosTramite = sessionStorage.getItem("datosTramite");
    await this.cargarPlanillas();
    await this.cargarDetalles();
  },

  watch: {
    p_idtramite() {
      this.cargarPlanillas();
      this.cargarDetalles();
    },
  },

  methods: {
    // ── Tab ───────────────────────────────────────────────────
    cambiarTab(tab) {
      this.tabActivo = tab;
    },

    // ── Carga de datos ────────────────────────────────────────
    async cargarPlanillas() {
      this.cargandoPlanillas = true;
      this.planillas         = [];
      try {
        const r        = await api.get(`/vwplanillas/idtramite-anuladas/${this.p_idtramite}`);
        this.planillas = (r.data ?? []);
        this.paginarPlanillas(1);
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar las planillas eliminadas." });
      } finally {
        this.cargandoPlanillas = false;
      }
    },

    async cargarDetalles() {
      this.cargandoDetalles = true;
      this.detalles         = [];
      try {
        const r       = await api.get(`/vwplanilladets/idtramite-anuladas/${this.p_idtramite}`);
        this.detalles = (r.data ?? []);
        this.paginarDetalles(1);
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los detalles eliminados." });
      } finally {
        this.cargandoDetalles = false;
      }
    },

    // ── Paginación planillas ──────────────────────────────────
    paginarPlanillas(n) {
      this.paginaActualPlanillas = Math.max(1, Math.min(n, this.totalPaginasPlanillas));
      const ini                  = (this.paginaActualPlanillas - 1) * this.elementosPorPaginaPlanillas;
      this.planillasPaginadas    = this.planillasFiltradas.slice(ini, ini + this.elementosPorPaginaPlanillas);
    },

    // ── Paginación detalles ───────────────────────────────────
    paginarDetalles(n) {
      this.paginaActualDetalles = Math.max(1, Math.min(n, this.totalPaginasDetalles));
      const ini                 = (this.paginaActualDetalles - 1) * this.elementosPorPaginaDetalles;
      this.detallesPaginados    = this.detallesFiltrados.slice(ini, ini + this.elementosPorPaginaDetalles);
    },

    // ── Páginas visibles con puntos suspensivos ───────────────
    _calcularPaginas(actual, total) {
      const delta = 2;
      const rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                         rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1)  rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Ordenamiento planillas ────────────────────────────────
    ordenarPorPlanilla(campo) {
      if (this.campoOrdenPlanilla === campo) {
        this.ascendentePlanilla = !this.ascendentePlanilla;
      } else {
        this.campoOrdenPlanilla = campo;
        this.ascendentePlanilla = true;
      }
      this.paginarPlanillas(1);
    },

    iconOrdenPlanilla(campo) {
      if (this.campoOrdenPlanilla !== campo) return "⇅";
      return this.ascendentePlanilla ? "↑" : "↓";
    },

    // ── Ordenamiento detalles ─────────────────────────────────
    ordenarPorDetalle(campo) {
      if (this.campoOrdenDetalle === campo) {
        this.ascendenteDetalle = !this.ascendenteDetalle;
      } else {
        this.campoOrdenDetalle = campo;
        this.ascendenteDetalle = true;
      }
      this.paginarDetalles(1);
    },

    iconOrdenDetalle(campo) {
      if (this.campoOrdenDetalle !== campo) return "⇅";
      return this.ascendenteDetalle ? "↑" : "↓";
    },

    // ── Badge estado ──────────────────────────────────────────
    badgeEstado(estado) {
      return {
        "bg-warning text-dark": estado === "PENDIENTE",
        "bg-success":           estado === "REVISADA",
        "bg-primary":           estado === "FINALIZADA",
        "bg-secondary":         !["PENDIENTE", "REVISADA", "FINALIZADA"].includes(estado),
      };
    },

    // ── Formateo ──────────────────────────────────────────────
    fmtFecha(fecha) {
      if (!fecha) return "";
      return new Date(fecha).toLocaleDateString("es-EC", {
        day:   "2-digit",
        month: "2-digit",
        year:  "numeric",
      });
    },

    fmtNum(valor) {
      return new Intl.NumberFormat("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor || 0);
    },

    // ── Exportar Excel planillas ──────────────────────────────
    exportarExcelPlanillas() {
      if (!this.planillas.length) {
        Swal.fire({ icon: "warning", title: "Sin datos", text: "No hay planillas para exportar." });
        return;
      }
      const headers = [
        "ID Planilla", "Número", "Cédula", "Nombre Paciente",
        "Diag 1", "Diag 2", "Cédula Médico", "Nombre Médico",
        "F. Desde", "F. Hasta", "Estado AM", "Estado GD", "ID Carga",
      ];
      const filas = this.planillasFiltradas.map(p => [
        p.idPlanilla, p.numero, p.cedula, p.nombre,
        p.diag1, p.diag2, p.cedulaMedico, p.nombreMedico,
        this.fmtFecha(p.fechaDesde), this.fmtFecha(p.fechaHasta),
        p.estadoAud, p.estadoDoc, p.idCarga,
      ]);
      this._descargarExcel([headers, ...filas], "Planillas_Eliminadas", `planillas_eliminadas_tramite_${this.p_idtramite}.xlsx`);
    },

    // ── Exportar Excel detalles ───────────────────────────────
    exportarExcelDetalles() {
      if (!this.detalles.length) {
        Swal.fire({ icon: "warning", title: "Sin datos", text: "No hay detalles para exportar." });
        return;
      }
      const headers = [
        "ID Detalle", "N.° Planilla", "Cédula", "Nombre Paciente",
        "F. Atención", "Código TPSNS", "Elemento TPSNS",
        "Cantidad", "Val. Unitario", "Val. Total",
        "Cód. Prestador", "Desc. Prestador",
      ];
      const filas = this.detallesFiltrados.map(d => [
        d.idPlanillaDet, d.planillaNumero, d.planillaCedula, d.planillaNombre,
        this.fmtFecha(d.fechaAtencion), d.elementoCodigo, d.elementoNombre,
        d.cantidad, d.valorUni, (d.cantidad * d.valorUni).toFixed(2),
        d.codigo, d.descripcion,
      ]);
      this._descargarExcel([headers, ...filas], "Detalles_Eliminados", `detalles_eliminados_tramite_${this.p_idtramite}.xlsx`);
    },

    _descargarExcel(aoa, sheetName, filename) {
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename);
    },
	
  abrirPlanillaPopup(idPlanilla) {
    abrirPlanillaPopup(idPlanilla);
  },
	
  },
};
</script>

<style scoped>
/* ── Barra de acciones ───────────────────────────────────────── */
.action-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.12s, transform 0.1s;
}
.action-btn:hover:not(:disabled) { filter: brightness(1.08); transform: translateY(-1px); }
.action-btn:disabled              { opacity: 0.5; cursor: default; }
.action-btn .material-symbols-outlined { font-size: 18px; }
.action-btn--green { background: #198754; color: #fff; }

/* ── Tabla ───────────────────────────────────────────────────── */
.table-hover tbody tr { cursor: default; }

/* ── Breadcrumb ──────────────────────────────────────────────── */
.breadcrumb-item a       { color: #0d6efd; text-decoration: none; }
.breadcrumb-item a:hover { text-decoration: underline; }

/* ── Ordenamiento ────────────────────────────────────────────── */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { background-color: #3d5166; }
.sort-icon     { font-size: 0.75rem; opacity: 0.8; }

/* ── Filtro de búsqueda ──────────────────────────────────────── */
.filter-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.filter-icon {
  position: absolute;
  left: 8px;
  font-size: 18px !important;
  color: #6c757d;
  pointer-events: none;
}
.filter-input {
  padding: 5px 32px 5px 32px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  width: 260px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.filter-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
}
.filter-clear {
  position: absolute;
  right: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  display: flex;
  align-items: center;
  transition: color 0.12s;
}
.filter-clear:hover { color: #dc3545; }

/* ── Nav tabs ────────────────────────────────────────────────── */
.nav-tabs .nav-link { color: #495057; }
.nav-tabs .nav-link.active { font-weight: 600; }
</style>